import React from "react";
import { USE_CASE_ICON_LABEL_MAP } from "utils/constants/useCases";
const DEFAULT_CLASSES = {
  container: "flex flex-row items-center pb2",
  copy: "f4 f3-5-l fw6 mt0-ns tl lh-title w-90 flex flex-shrink-0 pl2"
};

const UseCaseHeader = ({ type, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };

  return (
    <div className={classes.container}>
      <div className="useCase__container bg-white center w-100 relative">
        <div className={`image__cover--after useCase__icon--${type}`}></div>
      </div>
      <div className={classes.copy}>{USE_CASE_ICON_LABEL_MAP[type]}</div>
    </div>
  );
};
export default UseCaseHeader;
